import { createSlice } from '@reduxjs/toolkit';
import { fetchAvailableCenters } from 'thunks/centersThunks';

const initialState = {
  availableCenters: [],
  loading: false,
  error: null,
};

const centersSlice = createSlice({
  name: 'centers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAvailableCenters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAvailableCenters.fulfilled, (state, action) => {
        state.loading = false;
        state.availableCenters = action.payload;
      })
      .addCase(fetchAvailableCenters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default centersSlice.reducer;
